import {
    FETCH_AI_COMMAND_ITEMS,
    CLEAN_AI_COMMAND_ITEMS,
    RUN_AI_COMMAND_ITEM,
    RUN_AI_COMMAND_ITEMS,
    DELETE_AI_COMMAND_ITEM,
    DELETE_AI_COMMAND_ITEMS,
    EDIT_AI_COMMAND_ITEM,
    EDIT_AI_COMMAND_ITEMS,
    SAVE_AI_COMMAND_ITEMS,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const AI_COMMAND_ITEMS_DEFAULT_STATE = {};

const AiCommandItemsReducer = (state = AI_COMMAND_ITEMS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_AI_COMMAND_ITEMS:
            return payload;

        case RUN_AI_COMMAND_ITEM:
        case RUN_AI_COMMAND_ITEMS:
            return { ...state, items: _.map(state.items, item => {
                if (_.includes(payload, toNumber(item.id))) {
                    item = { ...item, status: 'waiting' };
                }

                return item;
            }) };

        case SAVE_AI_COMMAND_ITEMS:
            return { ...state, items: _.map(state.items, item => {
                if (_.has(payload.errors, item.item_id)) {
                    item = { ...item, error_save: payload.errors[item.item_id], saved: 0 };
                } else if (_.has(payload.success, item.item_id)) {
                    item = { ...item, error_save: null, saved: 1 };
                }

                return item;
            }) };

        case EDIT_AI_COMMAND_ITEM:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, ...payload.modified };
                }

                return item;
            }) };

        case EDIT_AI_COMMAND_ITEMS:
            return { ...state, items: _.map(state.items, item => {
                if (_.has(payload, toNumber(item.id))) {
                    item = { ...item, ...payload[toNumber(item.id)] };
                }

                return item;
            }) };

        case CLEAN_AI_COMMAND_ITEMS:
        case DELETE_AI_COMMAND_ITEM:
        case DELETE_AI_COMMAND_ITEMS:
            return AI_COMMAND_ITEMS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default AiCommandItemsReducer;
